import { config } from "@/config";
import { axiosExceptionToHttpError } from "@/utils/errorHandling";
import { resourceUrl } from "@/utils/stringUtils";
import axios, { AxiosResponse } from "axios";
import { HttpError } from "../core/HttpError";
import StoreModule from "../core/StoreModule";
import { $storageObject } from "../storage_object/store";
import { LayoutSourceState } from "./state";
import {
  LayoutSourceGetResponse,
  LayoutSourceMetadataPage,
  LayoutSourcePostPayload,
  RESOURCE_PATH,
} from "./types";

class LayoutSourceStore extends StoreModule<LayoutSourceState> {
  protected state: LayoutSourceState = {
    layoutSource: null,
  };

  get layoutSource() {
    return this.state.layoutSource;
  }

  set layoutSource(val: LayoutSourceState["layoutSource"]) {
    this.setState({ layoutSource: val });
  }

  getPageMetadata(idx: number) {
    return this.state.layoutSource?.metadata.pages.find(
      (page) =>
        page.index == (idx || this.state.layoutSource?.metadata.numberOfPages)
    ) as LayoutSourceMetadataPage;
  }
  async fetch(
    id: string
  ): Promise<[LayoutSourceState["layoutSource"] | null, HttpError | null]> {
    try {
      // Get layout source
      const resp = await axios.get<any, AxiosResponse<LayoutSourceGetResponse>>(
        resourceUrl(config.api.BASE_URL, RESOURCE_PATH, id)
      );
      // Set storage object
      $storageObject.layoutSourceObject = resp.data.storageObject;
      // Set layout source
      this.layoutSource = {
        id: resp.data.id,
        metadata: resp.data.metadata,
        createdAt: resp.data.createdAt,
        updatedAt: resp.data.updatedAt,
      };
      return [this.layoutSource, null];
    } catch (err: any) {
      console.log(err);
      if (err.name && err.name == "AxiosError") {
        return [null, axiosExceptionToHttpError(err)];
      }
      return [null, new HttpError(err.message, 500, err.stack)];
    }
  }

  async create(
    val: LayoutSourcePostPayload
  ): Promise<[LayoutSourceState["layoutSource"] | null, HttpError | null]> {
    try {
      // Save new layout source
      const resp = await axios.post<
        any,
        AxiosResponse<LayoutSourceGetResponse>,
        LayoutSourcePostPayload
      >(resourceUrl(config.api.BASE_URL, RESOURCE_PATH), val);
      // Set storage object
      $storageObject.layoutSourceObject = resp.data.storageObject;
      // Set layout source to persisted object
      this.layoutSource = {
        id: resp.data.id,
        metadata: resp.data.metadata,
        createdAt: resp.data.createdAt,
        updatedAt: resp.data.updatedAt,
      };
      return [this.layoutSource, null];
    } catch (err: any) {
      console.log(err);
      if (err.name && err.name == "AxiosError") {
        return [null, axiosExceptionToHttpError(err)];
      }
      return [null, new HttpError(err.message, 500, err.stack)];
    }
  }

  pageUrl(page: number) {
    return (
      resourceUrl(
        config.api.BASE_URL,
        RESOURCE_PATH,
        this.state.layoutSource?.id
      ) +
      "/render/" +
      (
        page || (this.state.layoutSource?.metadata.numberOfPages as number)
      ).toString()
    );
  }
}

export const $layoutSource = StoreModule.singleton(LayoutSourceStore);
